import React, { useState, useEffect } from "react";
import { XCircleIcon, EyeIcon } from "@heroicons/react/solid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { listGetCustomHeaders } from "../../../redux/actions/nrp/listActions";
import { useSelector, connect } from "react-redux";

import { customView } from "./data";
import { LocalStorageService } from "../../../services";
import { CheckBox, Radio } from "../../components";

// get step data from redux main state
const data = (state) => state.nrpList;

const CustomViewModal = (props) => {
  let { totalAssessments } = useSelector(data);

  // Personal Accordian State
  const [personalAccordian, setPersonalAccordian] = useState(true);
  const [personalAll, setPersonalAll] = useState(false);
  const [personalItems, setPeronalItems] = useState([]);
  const [personalHeaders, setPersonalHeaders] = useState([]);

  // Education Accordian State
  const [educationAccordian, setEducationAccordian] = useState(true);
  const [educationAll, setEducationAll] = useState(false);
  const [educationItems, setEducationItems] = useState([]);
  const [educationHeaders, setEducationHeaders] = useState([]);

  // Total Scores Accordian State
  const [totalScoresAccordian, settotalScoresAccordian] = useState(true);
  const [totalScoresAll, settotalScoresAll] = useState(false);
  const [totalScoresItems, settotalScoresItems] = useState([]);
  const [totalScoresHeaders, settotalScoresHeaders] = useState([]);

  // Interest Accordian State
  const [interestAccordian, setInterestAccordian] = useState(false);
  const [interestAll, setInterestAll] = useState(false);
  const [interestItems, setInterestItems] = useState([]);
  const [interestHeaders, setInterestHeaders] = useState([]);

  // Game Accordian State
  const [gameAccordian, setGameAccordian] = useState(false);
  const [gameAll, setGameAll] = useState(false);
  const [gameItems, setGameItems] = useState([]);
  const [gameHeaders, setGameHeaders] = useState([]);

  // Total Assessments State

  const [assessmentAccordian, setAssessmentAccordian] = useState(false);
  const [assessmentAll, setAssessmentAll] = useState(false);
  const [assessmentItems, setAssessmentItems] = useState([]);
  const [assessmentHeaders, setAssessmentHeaders] = useState([]);

  // Total Column

  const [allColumn, setAllColumn] = useState([]);

  // Personal Accordian functions
  let handelPersonalAllSelect = () => {
    setPersonalAll(!personalAll);
    if (!personalAll) {
      let personalItems = [];
      let personalHeaders = [];
      for (let i = 0; i < customView.personalMenu.length; i++) {
        const element = customView.personalMenu[i];
        personalItems.push(element.field);
        personalHeaders.push(element);
      }
      setPeronalItems(personalItems);
      setPersonalHeaders(personalHeaders);
      LocalStorageService.setObject("customListPersonalFeilds", personalItems);
    } else {
      setPeronalItems([]);
      setPersonalHeaders([]);
      LocalStorageService.remove("customListPersonalFeilds");
    }
  };

  let handelPersonalItem = (event, item) => {
    var updatedList = [...personalItems];
    if (event.target.checked) {
      updatedList = [...personalItems, event.target.value];
      personalHeaders.push(item);
    } else {
      updatedList.splice(personalItems.indexOf(event.target.value), 1);
      personalHeaders.splice(personalItems.indexOf(event.target.value), 1);
      setPersonalAll(!personalAll);
    }

    LocalStorageService.setObject("customListPersonalFeilds", updatedList);
    customView.personalMenu.length === updatedList.length
      ? setPersonalAll(true)
      : setPersonalAll(false);
    setPeronalItems(updatedList);
    setPersonalHeaders(personalHeaders);
  };

  // Education Accordian functions
  let handelEducationAllSelect = () => {
    setEducationAll(!educationAll);

    if (!educationAll) {
      let educationItems = [];
      let educationHeaders = [];
      for (let i = 0; i < customView.educationMenu.length; i++) {
        const element = customView.educationMenu[i];
        educationItems.push(element.field);
        educationHeaders.push(element);
      }
      setEducationItems(educationItems);
      setEducationHeaders(educationHeaders);
      LocalStorageService.setObject(
        "customListEducationFeilds",
        educationItems
      );
    } else {
      setEducationItems([]);
      setEducationHeaders([]);
      LocalStorageService.remove("customListEducationFeilds");
    }
  };

  let handelEducationItem = (event, item) => {
    var updatedList = [...educationItems];
    if (event.target.checked) {
      updatedList = [...educationItems, event.target.value];
      educationHeaders.push(item);
    } else {
      updatedList.splice(educationItems.indexOf(event.target.value), 1);
      educationHeaders.splice(educationItems.indexOf(event.target.value), 1);
      setEducationAll(!educationAll);
    }

    LocalStorageService.setObject("customListEducationFeilds", updatedList);
    customView.educationMenu.length === updatedList.length
      ? setEducationAll(true)
      : setEducationAll(false);
    setEducationItems(updatedList);
    setEducationHeaders(educationHeaders);
  };

  // Total Scores Accordian functions
  let handelTotalScoresAllSelect = () => {
    settotalScoresAll(!totalScoresAll);
    if (!totalScoresAll) {
      let totalScoresItems = [];
      let totalScoresHeaders = [];
      for (let i = 0; i < customView.totalScoresMenu.length; i++) {
        const element = customView.totalScoresMenu[i];
        totalScoresItems.push(element.field);
        totalScoresHeaders.push(element);
      }
      settotalScoresItems(totalScoresItems);
      settotalScoresHeaders(totalScoresHeaders);
      LocalStorageService.setObject(
        "customListTotalScoresFeilds",
        totalScoresItems
      );
    } else {
      settotalScoresItems([]);
      settotalScoresHeaders([]);
      LocalStorageService.remove("customListTotalScoresFeilds");
    }
  };

  let handelTotalScoresItem = (event, item) => {
    var updatedList = [...totalScoresItems];
    if (event.target.checked) {
      updatedList = [...totalScoresItems, event.target.value];
      totalScoresHeaders.push(item);
    } else {
      updatedList.splice(totalScoresItems.indexOf(event.target.value), 1);
      totalScoresHeaders.splice(
        totalScoresItems.indexOf(event.target.value),
        1
      );
      settotalScoresAll(!totalScoresAll);
    }

    LocalStorageService.setObject("customListTotalScoresFeilds", updatedList);
    customView.totalScoresMenu.length === updatedList.length
      ? settotalScoresAll(true)
      : settotalScoresAll(false);
    settotalScoresItems(updatedList);
    settotalScoresHeaders(totalScoresHeaders);
  };

  // Interest Accordian functions
  let handelInterestAllSelect = () => {
    setInterestAll(!interestAll);

    if (!interestAll) {
      let interestItems = [];
      let interestHeaders = [];
      for (let i = 0; i < customView.interestMenu.length; i++) {
        const element = customView.interestMenu[i];
        interestItems.push(element.field);
        interestHeaders.push(element);
      }
      setInterestItems(interestItems);
      setInterestHeaders(interestHeaders);
      LocalStorageService.setObject("customListInterestFeilds", interestItems);
    } else {
      setInterestItems([]);
      setInterestHeaders([]);
      LocalStorageService.remove("customListInterestFeilds");
    }
  };

  let handelInterestItem = (event, item) => {
    var updatedList = [...interestItems];
    if (event.target.checked) {
      updatedList = [...interestItems, event.target.value];
      interestHeaders.push(item);
    } else {
      updatedList.splice(interestItems.indexOf(event.target.value), 1);
      interestHeaders.splice(interestItems.indexOf(event.target.value), 1);
      setInterestAll(!interestAll);
    }

    LocalStorageService.setObject("customListInterestFeilds", updatedList);
    customView.interestMenu.length === updatedList.length
      ? setInterestAll(true)
      : setInterestAll(false);
    setInterestItems(updatedList);
    setInterestHeaders(interestHeaders);
  };

  // Game Accordian Functions

  let handelGamesAllSelect = () => {
    setGameAll(!gameAll);
    if (!gameAll) {
      let gameItems = [];
      let gameHeaders = [];
      for (let i = 0; i < customView.gameMenu.length; i++) {
        const element = customView.gameMenu[i];
        gameItems.push(element.field);
        gameHeaders.push(element);
      }
      setGameItems(gameItems);
      setGameHeaders(gameHeaders);
      LocalStorageService.setObject("customListGameFeilds", gameItems);
    } else {
      setGameItems([]);
      setGameHeaders([]);
      LocalStorageService.remove("customListGameFeilds");
    }
  };

  let handelGameItem = (event, item) => {
    var updatedList = [...gameItems];
    if (event.target.checked) {
      updatedList = [...gameItems, event.target.value];
      gameHeaders.push(item);
    } else {
      updatedList.splice(gameItems.indexOf(event.target.value), 1);
      gameHeaders.splice(gameItems.indexOf(event.target.value), 1);
      setGameAll(!gameAll);
    }
    LocalStorageService.setObject("customListGameFeilds", updatedList);
    customView.gameMenu.length === updatedList.length
      ? setGameAll(true)
      : setGameAll(false);
    setGameItems(updatedList);
    setGameHeaders(gameHeaders);
  };

  let handelAssessmentAllSelect = () => {
    let { assessmentMenu } = props;
    setAssessmentAll(!assessmentAll);
    if (!assessmentAll) {
      let assessmentItems = [];
      let assessmentHeaders = [];
      for (let i = 0; i < assessmentMenu.length; i++) {
        const element = assessmentMenu[i];
        assessmentItems.push(element.field);
        assessmentHeaders.push(element);
      }
      setAssessmentItems(assessmentItems);
      setAssessmentHeaders(assessmentHeaders);
      LocalStorageService.setObject(
        "customListAssessmentsFeilds",
        assessmentItems
      );
    } else {
      setAssessmentItems([]);
      setAssessmentHeaders([]);
      LocalStorageService.remove("customListAssessmentsFeilds");
    }
  };

  let handelAssessmentItem = (event, item) => {
    let { assessmentMenu } = props;

    var updatedList = [...assessmentItems];
    if (event.target.checked) {
      updatedList = [...assessmentItems, event.target.value];
      assessmentHeaders.push(item);
    } else {
      updatedList.splice(assessmentItems.indexOf(event.target.value), 1);
      assessmentHeaders.splice(assessmentItems.indexOf(event.target.value), 1);
      setAssessmentAll(!assessmentAll);
    }
    LocalStorageService.setObject("customListAssessmentsFeilds", updatedList);
    assessmentMenu.length === updatedList.length
      ? setAssessmentAll(true)
      : setAssessmentAll(false);
    setAssessmentItems(updatedList);
    setAssessmentHeaders(assessmentHeaders);
  };
  // Handel Custom
  let handelCustom = () => {
    let { assessmentMenu } = props;
    let personalSaved = LocalStorageService.getObject(
      "customListPersonalFeilds"
    );
    let educationSaved = LocalStorageService.getObject(
      "customListEducationFeilds"
    );
    let interestSaved = LocalStorageService.getObject(
      "customListInterestFeilds"
    );
    let totalScoresSaved = LocalStorageService.getObject(
      "customListTotalScoresFeilds"
    );
    let totalgameSaved = LocalStorageService.getObject("customListGameFeilds");
    let totalAssessmentSaved = LocalStorageService.getObject(
      "customListAssessmentsFeilds"
    );
    let headerColumns = [];
    if (Object.keys(personalSaved).length > 0) {
      let personalHeaders = [];
      setPeronalItems(personalSaved);
      customView.personalMenu.length === personalSaved.length
        ? setPersonalAll(true)
        : setPersonalAll(false);
      for (let i = 0; i < personalSaved.length; i++) {
        const element = personalSaved[i];
        var result = customView.personalMenu.find(
          (item) => item.field === element
        );
        personalHeaders.push(result);
        headerColumns.push(result);
      }
    }
    if (Object.keys(educationSaved).length > 0) {
      let educationHeaders = [];
      setEducationItems(educationSaved);
      customView.educationMenu.length === educationSaved.length
        ? setEducationAll(true)
        : setEducationAll(false);
      for (let i = 0; i < educationSaved.length; i++) {
        const element = educationSaved[i];
        var result = customView.educationMenu.find(
          (item) => item.field === element
        );
        educationHeaders.push(result);
        headerColumns.push(result);
      }
    }

    if (Object.keys(interestSaved).length > 0) {
      let interestHeaders = [];
      setInterestItems(interestSaved);
      customView.interestMenu.length === interestSaved.length
        ? setInterestAll(true)
        : setInterestAll(false);
      for (let i = 0; i < interestSaved.length; i++) {
        const element = interestSaved[i];
        var result = customView.interestMenu.find(
          (item) => item.field === element
        );
        interestHeaders.push(result);
        headerColumns.push(result);
      }
    }
    if (Object.keys(totalScoresSaved).length > 0) {
      let totalScoresHeaders = [];
      settotalScoresItems(totalScoresSaved);
      customView.totalScoresMenu.length === totalScoresSaved.length
        ? settotalScoresAll(true)
        : settotalScoresAll(false);
      for (let i = 0; i < totalScoresSaved.length; i++) {
        const element = totalScoresSaved[i];
        var result = customView.totalScoresMenu.find(
          (item) => item.field === element
        );
        totalScoresHeaders.push(result);
        headerColumns.push(result);
      }
    }

    if (Object.keys(totalgameSaved).length > 0) {
      let totalGamesHeaders = [];
      setGameItems(totalgameSaved);
      customView.gameMenu.length === totalgameSaved.length
        ? setGameAll(true)
        : setGameAll(false);
      for (let i = 0; i < totalgameSaved.length; i++) {
        const element = totalgameSaved[i];
        var result = customView.gameMenu.find((item) => item.field === element);
        totalGamesHeaders.push(result);
        headerColumns.push(result);
      }
    }

    if (Object.keys(totalAssessmentSaved).length > 0) {
      let totalAssessmentHeaders = [];
      setAssessmentItems(totalAssessmentSaved);
      assessmentMenu.length === totalAssessmentSaved.length
        ? setAssessmentAll(true)
        : setAssessmentAll(false);
      for (let i = 0; i < totalAssessmentSaved.length; i++) {
        const element = totalAssessmentSaved[i];
        var result = assessmentMenu.find((item) => item.field === element);
        totalAssessmentHeaders.push(result);
        headerColumns.push(result);
      }
    }
    props.listGetCustomHeaders(headerColumns);
    setAllColumn(headerColumns);
  };

  useEffect(() => {
    handelCustom();
  }, []);

  let { assessmentMenu } = props;
  return (
    <div>
      <div className="bg-[#007E8C] px-2 py-4 flex flow-row justify-between">
        <div className="flex flex-row items-center">
          <EyeIcon
            onClick={props.handelNo}
            className="w-7 cursor-pointer "
            color="white"
          />

          <h3 className="text-[#FFFFFF] ml-4 font-semibold  mt-[-2px]">
            Custom View List
          </h3>
        </div>
        <XCircleIcon
          onClick={props.handelNo}
          className="w-7 h-7 cursor-pointer "
          color="white"
        />
      </div>

      <div className="px-10 py-6">
        <div className="flex justify-around items-start flex-wrap">
          <Accordion
            expanded={personalAccordian}
            className="2xl:w-[32%] xl:w-[32%] lg:w-[40%] md:w-[40%]  w-[90%] "
          >
            <AccordionSummary
              expandIcon={
                <ChevronDownIcon
                  onClick={() => setPersonalAccordian(!personalAccordian)}
                  className="w-7 h-7 text-[#007E8C]"
                />
              }
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="flex flex-row items-center">
                <Radio
                  label="Personal"
                  checked={personalAll}
                  onChange={() => {
                    handelPersonalAllSelect();
                    handelCustom();
                  }}
                />
              </div>
            </AccordionSummary>
            <AccordionDetails style={{ marginTop: "-20px" }}>
              {customView.personalMenu &&
                customView.personalMenu.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="flex flex-row items-center justify-start"
                    >
                      <CheckBox
                        label={item.headerName}
                        id={`personal-${i}`}
                        key={i}
                        value={item.field}
                        selected={
                          personalItems && personalItems.includes(item.field)
                        }
                        onChange={(e) => {
                          handelPersonalItem(e, item);
                          handelCustom();
                        }}
                      />
                    </div>
                  );
                })}
            </AccordionDetails>
          </Accordion>
          <div className="2xl:w-[32%] xl:w-[32%] lg:w-[40%] md:w-[40%]  w-[90%] ">
            <Accordion expanded={educationAccordian}>
              <AccordionSummary
                expandIcon={
                  <ChevronDownIcon
                    onClick={() => setEducationAccordian(!educationAccordian)}
                    className="w-7 h-7 text-[#007E8C]"
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="flex flex-row items-center">
                  <Radio
                    label="Education"
                    checked={educationAll}
                    onChange={() => {
                      handelEducationAllSelect();
                      handelCustom();
                    }}
                  />
                </div>
              </AccordionSummary>
              <AccordionDetails style={{ marginTop: "-20px" }}>
                {customView.educationMenu &&
                  customView.educationMenu.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className="flex flex-row items-center justify-start"
                      >
                        <CheckBox
                          label={item.headerName}
                          id={`education-${i}`}
                          key={i}
                          value={item.field}
                          selected={
                            educationItems &&
                            educationItems.includes(item.field)
                          }
                          onChange={(e) => {
                            handelEducationItem(e, item);
                            handelCustom();
                          }}
                        />
                      </div>
                    );
                  })}
              </AccordionDetails>
            </Accordion>

            <Accordion style={{ marginTop: 20 }} expanded={interestAccordian}>
              <AccordionSummary
                expandIcon={
                  <ChevronDownIcon
                    onClick={() => setInterestAccordian(!interestAccordian)}
                    className="w-7 h-7 text-[#007E8C]"
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="flex flex-row items-center">
                  <Radio
                    label="Interest"
                    checked={interestAll}
                    onChange={() => {
                      handelInterestAllSelect();
                      handelCustom();
                    }}
                  />
                </div>
              </AccordionSummary>
              <AccordionDetails style={{ marginTop: "-20px" }}>
                {customView.interestMenu &&
                  customView.interestMenu.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className="flex flex-row items-center justify-start"
                      >
                        <CheckBox
                          label={item.headerName}
                          id={`interest-${i}`}
                          key={i}
                          value={item.field}
                          selected={
                            interestItems && interestItems.includes(item.field)
                          }
                          onChange={(e) => {
                            handelInterestItem(e, item);
                            handelCustom();
                          }}
                        />
                      </div>
                    );
                  })}
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="2xl:w-[32%] xl:w-[32%] lg:w-[40%] md:w-[40%]  w-[90%] ">
            <Accordion expanded={totalScoresAccordian}>
              <AccordionSummary
                expandIcon={
                  <ChevronDownIcon
                    onClick={() =>
                      settotalScoresAccordian(!totalScoresAccordian)
                    }
                    className="w-7 h-7 text-[#007E8C]"
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="flex flex-row items-center">
                  <Radio
                    label="Total Scores"
                    checked={totalScoresAll}
                    onChange={() => {
                      handelTotalScoresAllSelect();
                      handelCustom();
                    }}
                  />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {customView.totalScoresMenu &&
                  customView.totalScoresMenu.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className="flex flex-row items-center justify-start"
                      >
                        <CheckBox
                          label={item.headerName}
                          id={`education-${i}`}
                          key={i}
                          value={item.field}
                          selected={
                            totalScoresItems &&
                            totalScoresItems.includes(item.field)
                          }
                          onChange={(e) => {
                            handelTotalScoresItem(e, item);

                            handelCustom();
                          }}
                        />
                      </div>
                    );
                  })}
              </AccordionDetails>
            </Accordion>

            {/* Assessments */}

            <Accordion style={{ marginTop: 20 }} expanded={assessmentAccordian}>
              <AccordionSummary
                expandIcon={
                  <ChevronDownIcon
                    onClick={() => setAssessmentAccordian(!assessmentAccordian)}
                    className="w-7 h-7 text-[#007E8C]"
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="flex flex-row items-center">
                  <Radio
                    label="Assessment Results"
                    checked={assessmentAll}
                    onChange={() => {
                      handelAssessmentAllSelect();
                      handelCustom();
                    }}
                  />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {assessmentMenu &&
                  assessmentMenu.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className="flex flex-row items-center justify-start"
                      >
                        <CheckBox
                          label={item.headerName}
                          id={`game-${i}`}
                          key={i}
                          value={item.field}
                          selected={
                            assessmentItems &&
                            assessmentItems.includes(item.field)
                          }
                          onChange={(e) => {
                            handelAssessmentItem(e, item);
                            handelCustom();
                          }}
                        />
                      </div>
                    );
                  })}
              </AccordionDetails>
            </Accordion>

            <Accordion style={{ marginTop: 20 }} expanded={gameAccordian}>
              <AccordionSummary
                expandIcon={
                  <ChevronDownIcon
                    onClick={() => setGameAccordian(!gameAccordian)}
                    className="w-7 h-7 text-[#007E8C]"
                  />
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className="flex flex-row items-center">
                  <Radio
                    label="Game"
                    checked={gameAll}
                    onChange={() => {
                      handelGamesAllSelect();
                      handelCustom();
                    }}
                  />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {customView.gameMenu &&
                  customView.gameMenu.map((item, i) => {
                    return (
                      <div
                        key={i}
                        className="flex flex-row items-center justify-start"
                      >
                        <CheckBox
                          label={item.headerName}
                          id={`game-${i}`}
                          key={i}
                          value={item.field}
                          selected={gameItems && gameItems.includes(item.field)}
                          onChange={(e) => {
                            handelGameItem(e, item);
                            handelCustom();
                          }}
                        />
                      </div>
                    );
                  })}
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
      <div style={{ height: 10 }}></div>
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  listGetCustomHeaders,
})(CustomViewModal);
